module.exports = __webpack_public_path__ + "fr.svg?63f35221fabd1f8c9c1d54b30c10ab17";